const baseSrc = '//res.cloudinary.com/danrx4fes/image/upload/c_fill,h_634,ar_16:9/'

const bannerData = [
  'CAPA/01-CENTRO_DE_CONTROLES.jpg',
  'CAPA/02-PROJETO_CORPORATIVO.jpg',
  'CAPA/03-PROJETO_INDUSTRIAL.jpg',
  'capa-1',
]

export default bannerData.map((x) => baseSrc + x)
